import Edit from './Details';
export default Edit;
